import { Label } from '@fluentui/react-components';
import { Column } from '../../../common';
import { useAccountState } from '../../../../redux/reducers/accountReducer';
import { CaseDocument, Note, UserAccount } from '../../../../data/types';
import { useAccess } from '../../../../auth/useAccess';
import { CaseNoteForm } from '../../../controls/CaseNoteForm';
import { NoteControl } from '../../../controls/NoteControl';
import { useCaseServicesContext } from '../Cases/CaseServicesContext';

type DocumentNotesPanelProps = {
    selectedDoc?: CaseDocument;
    caseId?: string;
};

export const DocumentNotesPanel = (props: DocumentNotesPanelProps) => {
    const { selectedDoc, caseId } = props;

    const { noteService } = useCaseServicesContext()!;

    //Hooks
    const { primaryAccount } = useAccountState();
    const { user } = (primaryAccount as UserAccount) ?? {};
    const access = useAccess(user);

    //Access
    const canSeeNotesPanel = () => {
        return access.cases.canEditDocuments(caseId) && access.cases.canAddNotes(caseId);
    };

    //Logic
    const onSubmitNote = async (note: Note) => {
        const newNote: Note = { ...note, documentId: selectedDoc?.docId };

        await noteService.upsertCaseNoteAsync(newNote);
    };
    
    return (
        <Column gap='medium'>
            <Label size='large'>Notes</Label>

            {canSeeNotesPanel() && (
                <CaseNoteForm caseId={caseId} submitNote={onSubmitNote} vertical />
            )}
            <Column gap='medium' scroll>
                {noteService.notes.filter(x => x.documentId === selectedDoc?.docId)?.map((note: Note) => (
                    <NoteControl key={note.noteId} note={note} />
                ))}
            </Column>
        </Column>
    );
};
